module.exports = __webpack_public_path__ + "images/5d4f62a70c10e301ba2e917b26536ee0.svg";